// 查询仪表盘数据
import { apiUpateview } from '@/port/admins/instrument'//- 表格数据请求接口
import { timeSub, numberSub, textSub } from '@/api/instrumentControl';//- 封装方法请求
import { uploaderFun } from "@/api/utils.js";
import { getConfig, treemapClient, mapClient, objectToTree } from "@/components/clientSide/instrument/utils/getConfig";
import { visualizationClient } from '@/components/clientSide/instrument/common/indicatorsBread/js/color'
import store from "@/store/index.js"
import { cloneDeep } from 'lodash';
import { getResValue } from '@/components/schoolInstrument/component/mutual/common/config.js';
import { getFilterValue, setCustomData } from '@/util/customData'
import { getUserLists } from '@/components/clientSide/instrument/utils/utils.js'

export const getDetail = async (index, datas, { reportId, isSpace, spaceid, customDeskId }) => {
  let isData = true
  // 存在新版筛选就不要提前获取数据
  if (datas.toolbarList && datas.toolbarList.length > 0) {
    const newToolbarList = datas.toolbarList.filter(item => { return item.type === 'tool' })
    for (const tool of newToolbarList) {
      if (tool.info) {
        for (const item of tool.info) {
          if (item.type === 'screen') {
            isData = false
            break
          }
        }
      }
    }
  }
  if (!isData) return false
  datas.skeletonLoading = true;//- 开启骨架屏
  let mergeRules = [];
  if (datas.rules && datas.rules != undefined) {
    //- 外置筛选组件的筛选规则
    mergeRules = mergeRules.concat(datas.rules);
  }
  if (datas.relevanceRules && datas.relevanceRules != undefined) {
    //- 表单关联表单的筛选规则
    mergeRules = mergeRules.concat(datas.relevanceRules);
  }
  let submitDatas = {
    approvalDashboardId: reportId,//- 仪表盘id
    index: index,//- 仪表盘索引
    value: JSON.stringify(mergeRules),//- 筛选组件提交的筛选值
    curpage: datas.curpage,//- 当前页
    pagesize: datas.article,//- 每页条数
    export: '',//- 是否导出数据,1为导出，其它不导出
    querys: datas.querys ? datas.querys : '',//- 仪表盘验证过滤数据
  }
  // 从空间进入，需要传空间id
  if (isSpace) {
    let spaceId = typeof (spaceid) !== 'undefined' ? spaceid : localStorage.getItem('spaceid')
    submitDatas.spaceid = spaceId;
  }

  const customDataList = customDeskId ? store.state.doorCustomDataObj[customDeskId] : store.state.doorCustomData
  const filterCustomData = {}
  if (datas.filter && Array.isArray(datas.filter.linked)) {
    // - 公式字段提交数据生成
    datas.filter.linked.forEach(item => {
      // 如果是传给变量就不要走默认的过滤
      if (item.datatype === 'custom') {
        filterCustomData[item.name] = getFilterValue(item.conditionValue, customDataList)
      }
    })
  }
  if (customDataList) {
    // 存在$就是自定义的变量
    submitDatas.customData = setCustomData(customDataList)
  }
  if (datas.isSource === 2 && Array.isArray(datas.variableconfig) && datas.variableconfig.length > 0) {
    let customData = submitDatas.customData ? submitDatas.customData : {}
    datas.variableconfig.forEach(item => {
      customData[item.name] = item.value !== undefined ? item.value : ''
    })
    if (filterCustomData) {
      customData = { ...customData, ...filterCustomData }
    }
    submitDatas.customData = JSON.stringify(customData)
  }
  const res = await apiUpateview(submitDatas, datas.type).catch(() => {
    return -1
    // datas.skeletonLoading = false;//- 骨架屏消失
  });
  console.log('回来数据', JSON.parse(JSON.stringify(res)))
  datas.originalList = res.data?.originalDatas
  datas.skeletonLoading = false;//- 骨架屏消失
  if (res.code === 0) {
    // if (res.user) datas.user = res.user
    const user = res.user && res.user.length > 0 ? res.user : getUserList(res.data.list)
    console.log('自行获取的', JSON.parse(JSON.stringify(user)), getUserList(res.data.list))
    let date = res.data.list;
    date = dealFieldFn(date, datas)
    console.log(datas, 'datasdatasdatas')
    date = merge(date);
    console.log('处理完的数据', date)
    if (datas.type === 'detailed') {
      //- 明细表
      let selectDatas = datas.selectDatas;
      if (selectDatas && selectDatas.length > 0 && date && date.length > 0) {
        for (let i = 0; i < selectDatas.length; i++) {
          if (selectDatas[i].type === 'date'
            || selectDatas[i].type === 'file'
            || selectDatas[i].type === 'image'
            || selectDatas[i].type === 'number' && selectDatas[i].tempNumber
            || selectDatas[i].type === 'text' && selectDatas[i].encryption && selectDatas[i].encryption === true) {
            for (let a = 0; a < date.length; a++) {
              if (selectDatas[i].type === 'date') date[a][selectDatas[i].revisabilityName] = timeSub(date[a][selectDatas[i].revisabilityName], selectDatas[i].dayType && selectDatas[i].dayType[0] ? selectDatas[i].dayType[0] : 'yyyy-MM-dd');
              if (selectDatas[i].type === 'number') date[a][selectDatas[i].revisabilityName] = numberSub(date[a][selectDatas[i].revisabilityName], selectDatas[i].tempNumber);
              if (selectDatas[i].type === 'file' || selectDatas[i].type === 'image') date[a][selectDatas[i].revisabilityName] = uploaderFun(date[a][selectDatas[i].revisabilityName]);
              if (selectDatas[i].type === 'text') date[a][selectDatas[i].revisabilityName] = textSub(date[a][selectDatas[i].revisabilityName], 6);
            }
          }
        }
      }
      let new_array = formatChange(date);//- 明细表表格配置格式转换
      // 开启了卡片模式
      if (datas.showWay === 4) {
        try {
          const _fromdatas = cloneDeep(new_array)
          user.forEach((item, i) => {
            _fromdatas[i] = { ..._fromdatas[i], ...item }
          })
          new_array = await getConfig({
            cardConfig: datas.cardConfig,
            fromdatas: _fromdatas,
            curpage: datas.curpage,
            pagesize: datas.article,
            appid: datas.appId
          })
        } catch (e) {
          console.log('数据合并失败', e)
        }
        if (user && user.length > 0) {
          try {
            let allDatas = []
            if (datas.cardConfig && datas.cardConfig.configList) {
              allDatas = datas.cardConfig.configList[0].children
            }
            const getu = await getUserLists(user, allDatas)
            for (let s = 0; s < new_array.length; s++) {
              new_array[s] = { ...new_array[s], ...getu[s] }
            }
          } catch (err) { console.log(err) }
        }
        console.log('查询刷新', new_array)
      }

      // 如果是无限滚动
      if (datas.loadSetting && datas.loadSetting === 'scroll' && datas.curpage > 1) {
        if (user && user.length > 0) datas.user = datas.user.concat(user)
        datas.fromdatas = datas.fromdatas.concat(new_array);
      } else {
        if (user && user.length > 0) datas.user = user
        datas.fromdatas = new_array;
      }
      datas.pageTotal = res.total;
    }
    console.log('返回的数据', datas)
    return datas

  } else {
    return datas
  }

}

// 把数据里面的联系人数据提取出来
function getUserList(date) {
  let arr = [];
  for (let i = 0; i < date.length; i++) {
    let str = {};
    for (let e in date[i]) {
      if (typeof date[i][e] === 'object') {
        let retStr = retUser(date[i][e], e);
        str = Object.assign(str, retStr);
      }
    }
    arr.push(str);
  }
  return arr;
}

export function retUser(data, name) {
  let strObj = {};
  // 区分 [] 和 {}
  if (Array.isArray(data)) {
    if (data[0] && data[0].realname) {
      strObj[name] = data;
    }
  } else {
    if (data.realname) {
      strObj[name] = data;
    } else {
      for (let i in data) {
        if (typeof data[i] === 'object') {
          let retStrs = retsule(data[i], (name + '.' + i));
          strObj = Object.assign(strObj, retStrs);
        }
      }
    }
  }
  return strObj;
}
//- 指标图/饼图/汇总/明细客户端数据格式改造
export function retsule(data, name) {
  let strObj = {};
  // 区分 [] 和 {}
  if (Array.isArray(data)) {
    if (data[0] && (data[0].realname || data[0].name)) {
      let ars = data.map(val => { return val.realname || val.name });
      strObj[name] = ars.join(',');
    } else if (data[0] && data[0].response) {
      strObj[name] = data;
    } else if (data[0] && data[0].date && data[0].time) {
      // 他是属于预约时间段的，不做任何转化
      strObj[name] = data
    } else {
      strObj[name] = data.join(',');
    }
  } else {
    if (data.realname) {
      strObj[name] = data.realname;
    } else {
      for (let i in data) {
        if (typeof data[i] === 'object') {
          let retStrs = retsule(data[i], (name + '.' + i));
          strObj = Object.assign(strObj, retStrs);
        } else {
          strObj[name + '.' + i] = data[i];
        }
      }
    }
  }
  return strObj;
}

//- 汇总过滤方法
export function merge(date) {
  let arr = [];
  for (let i = 0; i < date.length; i++) {
    let str = {};
    for (let e in date[i]) {
      if (typeof date[i][e] === 'object') {
        let retStr = retsule(date[i][e], e);
        str = Object.assign(str, retStr);
      } else {
        str[e] = date[i][e];
      }
    }
    arr.push(str);
  }
  return arr;
}

function dealFieldFn(date, datas) {
  datas.customField = []
  if (date && date[0]) {
    let allData = null
    const hideField = []
    if (datas.toolbarList) {
      for (const ele of datas.toolbarList) {
        const info = ele.info
        if (Array.isArray(info)) {
          for (const cele of info) {
            if (cele.type === 'button' && cele.info.bindingFunction === 'field-show' && cele.info.showFieldInfo && cele.info.showFieldInfo.fieldShowType === 'single' && !cele.info.showFieldInfo.fieldShowAll) {
              hideField.push(...cele.info.showFieldInfo.showFieldList)
            }
          }
        }
      }
    }
    for (const sel of datas.selectDatas) {
      if (sel.previewFormat && sel.previewFormat === 'object') {
        allData = cloneDeep(sel)
        sel.isHide = true
        allData.isHide = false
        let sortConfig = sel.customOptionConfig
        if (sortConfig) {
          sortConfig = sortConfig.split(/\r\n|\n|\r/)
        }
        const value = getResValue(date, allData.title)
        if (value && typeof value === 'object') {
          let formula = []
          let addFormulaArr = []
          if (datas.isTodoList) {
            const listTodoConfig = datas.listTodoConfig || []
            const todoItem = listTodoConfig.find(item => item.title === allData.title)
            const info = todoItem ? todoItem.info : {}
            if (info.workshopInfo && info.workshopInfo.formula) {
              formula = info.workshopInfo.formula
              addFormulaArr = info.workshopInfo.addFormulaArr
            }
          }
          let filed = objectToTree(value, {
            customOptions: allData,
            childrenKey: 'list',
            isDetailed: true,
            config: datas,
            formula,
            addFormulaArr,
            hideField,
            objectToTree,
            sortConfig
          })
          // if (sortConfig) {
          //   filed = filed.sort((a, b) => {
          //     const idxA = sortConfig.indexOf(a.title)
          //     const idxB = sortConfig.indexOf(b.title)
          //     if (idxA > -1 && idxB > -1) {
          //       return idxA - idxB
          //     } else if (idxA > -1) {
          //       return -1
          //     } else if (idxB > -1) {
          //       return 1
          //     } else {
          //       return 0
          //     }
          //   })
          // }
          if (datas.customField) {
            datas.customField.push(...filed)
          } else {
            datas.customField = filed
          }
        }
      } else {
        let isHide = false
        if (hideField.length !== 0) {
          isHide = hideField.includes(sel.name)
        }
        sel.isHide = isHide
      }
    }
    console.log(datas.selectDatas, 'datas.selectDatas')
    if (!allData) return date
  }
  return date
}

//- 明细表表格配置格式转换
export function formatChange(date) {
  let new_array = [];
  date.forEach((detail) => {
    let new_obj = {}
    for (let j in detail) {
      let new_key = j.split(".");
      new_key = new_key.join("");
      new_obj[new_key] = detail[j]
    }
    new_array.push(new_obj)
  })
  return new_array;
}

export const getIndicatorsBread = async (index, datas, { reportId, isSpace, spaceid, upaceid, customDeskId }) => {
  console.log('开始执行getIndicatorsBread', index, datas, reportId, isSpace, spaceid, upaceid)
  let mergeRules = []
  if (datas.rules && datas.rules !== undefined) {
    // 外置筛选组件的筛选规则
    mergeRules = mergeRules.concat(datas.rules)
  }
  if (datas.relevanceRules && datas.relevanceRules !== undefined) {
    // 表单关联表单的筛选规则
    mergeRules = mergeRules.concat(datas.relevanceRules)
  }
  const submitDatas = {
    approvalDashboardId: reportId, // - 仪表盘id
    index: index, // - 仪表盘索引
    value: JSON.stringify(mergeRules), // - 筛选组件提交的筛选值
    curpage: datas.devCurpage, // - 当前页 (如果是汇总，该值传0)
    pagesize: datas.devArticle, // - 每页条数 (如果是汇总，该值传0)
    export: '', // - 是否导出数据,1为导出，其它不导出
    ref: 1,
    // querys: item.querys ? item.querys : '',// - 仪表盘验证过滤数据
  }
  // 从空间进入，需要传空间id
  if (isSpace) {
    submitDatas.spaceid = spaceid
  }
  if (upaceid) {
    submitDatas.upaceid = upaceid
  }
  const customDataList = customDeskId ? store.state.doorCustomDataObj[customDeskId] : store.state.doorCustomData
  if (customDataList) {
    // 存在$就是自定义的变量
    submitDatas.customData = setCustomData(customDataList)
  }
  if (datas.isSource === 2 && Array.isArray(datas.variableconfig) && datas.variableconfig.length > 0) {
    const customData = submitDatas.customData ? submitDatas.customData : {}
    datas.variableconfig.forEach(item => {
      customData[item.name] = item.value !== undefined ? item.value : ''
    })
    submitDatas.customData = JSON.stringify(customData)
  }
  // eslint-disable-next-line handle-callback-err
  const res = await apiUpateview(submitDatas, datas.type).catch(() => { return -1 })
  console.log('读取结果', res)
  if (res.code === 0) {
    let date = res.data.list
    if (datas.reverseOrder) date = date.reverse()
    date = mergeFun(date)
    if (JSON.stringify(date) === '[{}]') {
      datas.totalValue = null
      datas.tableData = []
    } else {
      // 获取总值
      const cols = res.data.cols
      const list = res.data.list
      var totalValue = 0

      // 特殊加料
      const row = datas.row
      const column = datas.column
      if (row && row.length > 0 && date && date.length > 0) {
        for (let i = 0; i < row.length; i++) {
          const rowItem = row[i]
          if ((row[i].type === 'date' || row[i].type === 'number') && row[i].format) {
            const rowName = (rowItem.revisabilityName || rowItem.name)
            for (let a = 0; a < date.length; a++) {
              date[a][rowItem.revisabilityName || rowItem.name] = date[a][rowName] || date[a][rowName] === 0 ? date[a][rowName] : date[a][rowName + '显示格式']
            }
          }
        }
      }
      if (column && column.length > 0 && date && date.length > 0) {
        for (let i = 0; i < column.length; i++) {
          const columnItem = column[i]
          const columnName = (columnItem.revisabilityName || columnItem.name)
          for (let a = 0; a < date.length; a++) {
            date[a][columnItem.revisabilityName || columnItem.name] = date[a][columnName] || date[a][columnName] === 0 ? date[a][columnName] : date[a][columnName + '显示格式']
          }
        }
      }
      console.log('加料完毕', date)
      if (datas.chartType === 'indicators') {
        if (datas.row.length === 0) {
          // 单行指标图显示总数
          const value = mergeFun(list)
          for (const i in value[0]) {
            totalValue = value[0][i]
          }
        } else if (datas.row.length > 0) {
          // 双行指标图显示总数
          for (const i in cols) {
            totalValue = cols[i]
          }
        }
      }
      console.log('判断类型', datas, datas.chartType, datas.chartType === 'treemap')
      // 地图另外来
      if (datas.chartType === 'gdMap') {
        datas.tableData = mapClient({
          date: date,
          row: datas.row,
          column: datas.column,
          summary: datas.summary,
          config: datas.gdMapConfig
        })
        console.log('地图的转码', datas.tableData)
      } else if (datas.chartType === 'treemap') {
        datas.tableData = treemapClient({
          list: date,
          row: datas.row,
          column: datas.column,
          summary: datas.summary,
          config: datas.gdMapConfig,
          cols: res.data.cols
        })
      } else {
        // 表格数据
        if (datas.row.length === 0) {
          datas.tableData = []
        } else {
          // 有列字段另说
          if (datas.column && datas.column.length > 0) {
            datas.tableData = visualizationClient({
              row: datas.row,
              column: datas.column,
              summary: datas.summary,
              date: datas.seriesType === 'name' ? list : date,
              type: datas.chartType,
              seriesType: datas.seriesType
            })
            console.log('可视化有列字段，另说', datas.tableData, datas)
          } else {
            datas.tableData = valueRemould(date, datas.row, datas.summary, datas.seriesType) // 结果集
          }
        }
      }
      datas.totalValue = totalValue
    }
    datas.pageTotal = res.total
    datas.pages = res.pages
    console.log('会跑数据', datas)
    return datas
  } else {
    return datas
  }
}

// 指标图/饼图客户端值改造(1)
function valueRemould(data, row, summary, seriesType) {
  const res = data
  const arr = []
  console.log(seriesType, 'asdad')
  if (seriesType === 'name') {
    // 循环行
    summary.forEach((s, index) => {
      // 定义对象容器
      const obj = {}
      // 获取行名
      const name = s.name1
      // 获取汇总名
      const sname = s.name
      // 获取计算类型
      const m = sname.search(/\(/)
      const n = sname.search(/\)/)
      const summaryType = sname.slice(m + 1, n)
      console.log(name, sname, summaryType)
      // 定义数组存储对应行名数据
      let value = 0
      // 循环数据 item为对象
      for (let i = 0; i < data.length; i++) {
        switch (summaryType) {
          case '求和':
          case '计数':
            value += data[i][sname]
            break
          case '求平均':
            value += data[i][sname]
            if (i === data.length - 1) {
              value = value / data.length
            }
            break
          case '求最大值':
            if (i === 0) value = data[0][sname]
            value = value > data[i][sname] ? value : data[i][sname]
            break
          case '求最小值':
            if (i === 0) value = data[0][sname]
            value = value < data[i][sname] ? value : data[i][sname]
            break
        }
      }
      obj.name = name || ''
      obj.value = value
      if (index === 0) obj.seriesType = seriesType
      arr.push(obj)
    })
    console.log(arr)
    return arr
  }
  const statObj = {
    0: '进行中',
    1: '已通过',
    2: '未通过',
    3: '已撤回'
  }
  for (const i of res) {
    const obj = {
      name: ''
    }
    for (const r of row) {
      const rowName = r.name + (r.type === 'date' && r.format !== 'yyyy-MM-dd HH:mm:ss' ? "(因为时间字段特殊)" : '')
      obj.name += (!obj.name && obj.name !== 0 ? '' : '\u0001') + (r.type === 'status' && statObj[i[rowName]] ? statObj[i[rowName]] : i[rowName] || i[rowName] === 0 ? i[rowName] : i[r.name] || '')
    }
    for (const s of summary) {
      const summaryName = row.length === 0 ? s.revisabilityName : s.name + (row.length === 0 ? '(单个指标图特殊显示)' : '')
      obj[s.title] = (i[summaryName] || i[summaryName] === 0 ? i[summaryName] : i[s.name]) || ''
    }
    arr.push(obj)
  }
  console.log('指标图结果返回', arr, data, row)
  return arr
}
// 指标图/饼图客户端数据格式改造(2)
function mergeFun(date) {
  const arr = []
  if (date && date.length > 0) {
    for (let i = 0; i < date.length; i++) {
      let str = {}
      for (const e in date[i]) {
        if (typeof date[i][e] === 'object') {
          const retStr = retsule(date[i][e], e)
          str = Object.assign(str, retStr)
        } else {
          str[e] = date[i][e]
        }
      }
      arr.push(str)
    }
  }
  return arr
}
